import VenueFacilitiesModel from '@/shared/models/venue/VenueFacilitiesModel';
class VenueFacilitiesForm extends VenueFacilitiesModel {
    mandatoryConfirm;
}
export default VenueFacilitiesForm;
